import React from 'react';
import PublicationTitleContainer from './PublicationTitleContainer';
import Authors from './Authors';
import PublicationData from './PublicationData';

export default function PublicationDetails({
  doc,
  track,
  query,
  currentPage,
  position,
  isSuggested,
}) {
  return (
    <div className="publication-details" data-name="publication-details">
      <PublicationTitleContainer
        doc={doc}
        track={track}
        query={query}
        currentPage={currentPage}
        position={position}
        isSuggested={isSuggested}
      />
      <Authors doc={doc} track={track} />
      <PublicationData doc={doc} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationDetails.js